import { render, staticRenderFns } from "./PhaseBehavior.vue?vue&type=template&id=39c4db76&"
import script from "./PhaseBehavior.vue?vue&type=script&lang=js&"
export * from "./PhaseBehavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports